<div class="record-timeline d-flex flex-column">
    @for (year of timelineRecords().keys(); track $index) 
    {
        <p class="record-timeline-year nunito-bold">
            {{year}}
        </p>
        <div class="vp-16 d-flex flex-column">
            @for (record of timelineRecords().get(year); track $index)
            {
                <div class="d-flex align-items-center gap-2">
                    <div class="record-month position-relative d-flex align-items-center">
                        <p class="month nunito-semibold">
                            {{getRecordMonth(record)}}
                        </p>
                    </div>
                    <app-record-card [record]="record" />
                </div>
            }
        </div>
    }
    @empty 
    {
        <div class="d-flex flex-column align-items-center justify-content-center">
            <svg-icon src="assets/icons/no-records-placeholder.svg" />
            <p class="nunito-regular records-placeholder">
                {{'PATIENT_TIMELINE_INFORMATION.RECORDS_PLACEHOLDER' | translate}}
            </p>
        </div>
    }
</div>
